<template>
  <div class="footer">
    <div class="footerbox">
      <div class="columnList">
        <div class="itembox" style="width: 32%" v-if="pageConfig.id == 8">
          <h3>Customer Support</h3>
          <!-- 电话列表 -->
          <div class="textinfo">
            <!-- <div class="textl">Sydney</div> -->
            <div class="textm">
              <!-- <div class="top">Speak to an agent:</div>
              <div class="bottom">Urgent enquiry:</div>
              <div class="bottom">For Change booking:</div> -->
              <div class="top">Contact Agent (9am-5pm AEST, Toll free)</div>
            </div>
            <div class="textr">
              <div class="top">
                {{ pageConfig.tel_general_enquiries }}(Australia)
              </div>
              <div class="bottom">
                {{ pageConfig.tel_from_overseas }}(Overseas)
              </div>
              <!-- <div class="bottom">{{ pageConfig.support_mail }}</div> -->
            </div>
          </div>
        </div>
        <div class="itembox" v-else>
          <h3>24/7 Customer Support</h3>
          <!-- 电话列表 -->
          <div class="textinfo">
            <!-- <div class="textl">Sydney</div> -->
            <div class="textm">
              <div class="top">General enquiries: {{ pageConfig.tel_general_enquiries }}</div>
              <div class="bottom">From overseas: {{ pageConfig.tel_from_overseas }}</div>
            </div>
            <!-- <div class="textr">
              <div class="top">{{ pageConfig.tel_general_enquiries }}</div>
              <div class="bottom">{{ pageConfig.tel_from_overseas }}</div>
            </div> -->
          </div>
        </div>
        <!-- 盒子 -->
        <div class="itembox" v-if="pageConfig.id == 8">
          <h3>{{ domain }}</h3>
          <div class="aboutInfo">
            <!-- <router-link to="/about">About Us</router-link> -->
            <router-link to="/Contact">Contact Us</router-link>
            <!-- <router-link to="/term">Terms and Conditions</router-link> -->
            <!-- <router-link to="/privacy">Travel News</router-link> -->
            <router-link to="/newsList">Travel News</router-link>
            <!-- <router-link to="contact">Contact Us</router-link> -->
          </div>
        </div>
        <div class="itembox" v-else>
          <h3>{{ domain }}</h3>
          <div class="aboutInfo">
            <router-link to="/about">About Us</router-link>
            <router-link to="/Contact">Contact Us</router-link>
            <router-link to="/term">Terms and Conditions</router-link>
            <!-- <router-link to="/privacy">Travel News</router-link> -->
            <router-link to="/newsList">Travel News</router-link>

            <!-- <router-link to="contact">Contact Us</router-link> -->
          </div>
        </div>
        <!-- 盒子 -->
        <!-- <div class="itembox">
          <h3>Terms Conditions</h3>
          <router-link to="term">Terms and Conditions</router-link>
          <router-link to="privacy">Privacy</router-link>
        </div> -->
        <!-- 盒子 -->
        <div class="itembox" v-if="pageConfig.id == 8">
          <h3>{{ domain }}</h3>
          <div class="ours">
            <router-link to="/about">About Us</router-link>
            <router-link to="/term">Terms and Conditions</router-link>
            <span v-if="pageConfig.address !== ''">{{
              pageConfig.address
            }}</span>
            <span v-if="pageConfig.hours !== ''">Hours: {{ pageConfig.hours }}</span>
            <!-- <span v-if="pageConfig.phone !== ''"
              >Phone: {{ pageConfig.phone }}</span
            > -->
            <!-- <span v-if="pageConfig.support_mail !== ''"
              >Support email: {{ pageConfig.support_mail }}</span
            >
            <span v-if="pageConfig.feedback_mail !== ''"
              >Feedback email: {{ pageConfig.feedback_mail }}</span
            >
            <span v-if="pageConfig.business_mail !== ''"
              >Business email: {{ pageConfig.business_mail }}</span
            > -->
          </div>
        </div>
        <div class="itembox" v-else>
          <h3>Our Store</h3>
          <div class="ours">
            <span v-if="pageConfig.address !== ''">Address: {{ pageConfig.address }}</span>
            <span v-if="pageConfig.hours !== ''">Hours: {{ pageConfig.hours }}</span>
            <span v-if="pageConfig.phone !== ''">Phone: {{ pageConfig.phone }}</span>
            <span v-if="pageConfig.support_mail !== ''">Support email: {{ pageConfig.support_mail }}</span>
            <span v-if="pageConfig.feedback_mail !== ''">Feedback email: {{ pageConfig.feedback_mail }}</span>
            <span v-if="pageConfig.business_mail !== ''">Business email: {{ pageConfig.business_mail }}</span>
          </div>
        </div>
      </div>
      <div class="logoList">
        <div class="logobox" v-if="pageConfig.id == 8">
          <div class="pic">
            <img src="@/assets/img/cooperation1.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation2.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation3.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation6.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation4.png" alt="Alternate Text" />
          </div>
          <!-- <div class="pic">
            <img src="@/assets/img/cooperation5.png" alt="Alternate Text" />
          </div> -->
        </div>
        <div class="logobox" v-else>
          <div class="pic">
            <img src="@/assets/img/cooperation1.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation2.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation3.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation6.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation4.png" alt="Alternate Text" />
          </div>
          <div class="pic">
            <img src="@/assets/img/cooperation5.png" alt="Alternate Text" />
          </div>
        </div>
        <div class="record" v-html="pageConfig.copyright"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "newfooter",
  components: {},

  data() {
    return {
      domain: "",
    };
  },
  created() {
    this.domain = window.location.hostname;
    // console.log(this.domain);
  },
  computed: mapState({
    pageConfig: (state) => state.common.pageConfig,
  }),
  methods: {
    goLink() { },
    processData(value) {
      let text = "";
      switch (value) {
        case 8:
          text = "aoflights";
          break;
        case 9:
          text = "etrip travel";
          break;
        case 10:
          text = "Himytrip";
          break;
        case 11:
          text = "faith travel";
          break;
        case 14:
          text = "yiqufei";
          break;
        case 16:
          text = "happyeasygo";
          break;
        default:
          text = "OURS";
          break;
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./footer.scss";
@import "./mfooter.scss";
</style>
